module.exports = __webpack_public_path__ + "static/media/trampoline.f4bc93b5.png";